import { useState } from "react";
import "./Contact.css";
import whatsapp from "../../assets/whatsapp.png";

export default function Contact() {
  const [nom, setNom] = useState("");
  const [adresse, setAdresse] = useState("");
  const [message, setMessage] = useState("");

  const sendWhatsApp = (e) => {
    e.preventDefault();

    const numero = "33612425201"; // 🔥 Mets ici ton numéro SANS + 

    const texte = `
*Nom :* ${nom}
*Adresse :* ${adresse}
*Message :* ${message}
    `;

    const url = `https://wa.me/${numero}?text=${encodeURIComponent(texte)}`;

    window.open(url, "_blank");
  };

  return (
    <section id="contact" className="contact container">
      <img src={whatsapp} alt="" />
      <h2 className="section-title">
        Contactez-<span className="yellow">nous</span>
      </h2>

      <form className="contact-form" onSubmit={sendWhatsApp}>
        <input
          type="text"
          placeholder="Nom"
          required
          value={nom}
          onChange={(e) => setNom(e.target.value)}
        />

        <input
          type="text"
          placeholder="Adresse"
          value={adresse}
          onChange={(e) => setAdresse(e.target.value)}
        />

        <textarea
          placeholder="Message"
          rows="5"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />

        <button>Envoyer</button>
      </form>
      <div className="contact-info">
          <h3>Infos</h3>
          <p>
            📍 Adresse: <strong>7 Traverse de la Michèle, 13015 Marseille</strong>
          </p>
          <p>
            📞 Téléphone:{" "}
            {/* <ul> */}
            <strong>
              <a href="tel:+33612425201">06 12 42 52 01</a> <br />
            </strong>
           
            {/* </ul> */}
          </p>
          <p>
           📧 Email:{" "}
            <strong>
              <a href="mailto:servicecleanpromarseille@hotmail.com">servicecleanpromarseille@hotmail.com</a>
            </strong><br />
            <strong>
              <a href="mailto:cleandrone@outlook.com">cleandrone@outlok.com</a>
            </strong>
          </p>

          <p>
            SIRET:{" "}
            <strong>
              980 042 757 00013
            </strong>
          </p>
          
        </div>
    </section>
  );
}
